import { Route, Routes } from "react-router-dom";
import HeaderBase from "./HeaderBase";

const Header = () => {

    return (

        <Routes>
            <Route  path='/trans' element={<HeaderBase  />} />
            <Route  path='/trans/add' element={<HeaderBase  />} />
            <Route  path='/accumulative' element={<HeaderBase  />} />
            <Route  path='/settlements' element={<HeaderBase  />} />
            <Route  path='/installments/factors' element={<HeaderBase  />} />
            <Route  path='/authentication' element={<HeaderBase  />} />
        </Routes>

    );
}

export default Header;